import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Bluetooth Apps">
                <h1>Bluetooth Low Energy App Development Services</h1>
              </div>
              <p className="main_para">
                That build smart solution for your devices
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Deliver low-consumption interactive experiences to your end
                users through beacon-based digital products.
              </p>
              <ul>
                <li>Secure Digital Connections Across Devices</li>
                <li>Turnkey Wearable Development Solutions</li>
                <li>Real-Time Data Synchronization</li>
                <li>High-End UX with Connected Devices</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
